function rankCollectionAnswers(selectedAnswers) {
  const candidates = new Map();

  selectedAnswers.forEach((input, index) => {
    const url = input.dataset.collectionUrl;
    if (!url) return;

    const existing = candidates.get(url);
    if (existing) {
      existing.count += 1;
      return;
    }

    candidates.set(url, {
      title: input.dataset.collectionTitle || '',
      url,
      count: 1,
      firstIndex: index,
    });
  });

  let winner;
  candidates.forEach((candidate) => {
    // Tie-break: keep the collection that first appears in questionnaire order, so the final question has no automatic advantage.
    if (!winner || candidate.count > winner.count || (candidate.count === winner.count && candidate.firstIndex < winner.firstIndex)) {
      winner = candidate;
    }
  });

  return winner;
}

if (!customElements.get('cd-sleep-finder')) {
  class CloudDreamSleepFinder extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-cd-finder-form]');
      this.questions = [...this.querySelectorAll('[data-cd-finder-question]')];
      this.result = this.querySelector('[data-cd-finder-result]');
      if (!this.form || this.questions.length === 0 || !this.result) return;

      this.index = 0;
      this.questions.forEach((question) => {
        question.querySelector('[data-cd-finder-next]')?.addEventListener('click', () => this.next());
        question.querySelector('[data-cd-finder-back]')?.addEventListener('click', () => this.back());
        question.addEventListener('change', () => {
          const error = question.querySelector('[data-cd-finder-error]');
          if (error) error.hidden = true;
          question.setAttribute('aria-invalid', 'false');
        });
      });
      this.querySelector('[data-cd-finder-restart]')?.addEventListener('click', () => this.restart());
      this.render();
    }

    next() {
      const question = this.questions[this.index];
      const selected = question.querySelector('input[type="radio"]:checked');
      const error = question.querySelector('[data-cd-finder-error]');
      if (!selected) {
        if (error) error.hidden = false;
        question.setAttribute('aria-invalid', 'true');
        question.querySelector('input[type="radio"]')?.focus();
        return;
      }
      if (this.index < this.questions.length - 1) {
        this.index += 1;
        this.render(true);
      } else {
        this.showResult();
      }
    }

    back() {
      if (this.index === 0) return;
      this.index -= 1;
      this.render(true);
    }

    render(focus = false) {
      this.result.hidden = true;
      this.questions.forEach((question, index) => {
        const active = index === this.index;
        question.hidden = !active;
        question.classList.toggle('is-active', active);
        const back = question.querySelector('[data-cd-finder-back]');
        if (back) back.hidden = this.index === 0;
      });
      const progress = ((this.index + 1) / this.questions.length) * 100;
      const text = this.querySelector('[data-cd-finder-progress-text]');
      const fill = this.querySelector('[data-cd-finder-progress-fill]');
      if (text) text.textContent = `${this.index + 1} / ${this.questions.length}`;
      if (fill) fill.style.width = `${progress}%`;
      if (focus) this.focusQuestionHeading();
    }

    focusQuestionHeading() {
      this.questions[this.index]?.querySelector('[data-cd-finder-heading]')?.focus();
    }

    showResult() {
      const data = new FormData(this.form);
      const selected = [...this.form.querySelectorAll('input[type="radio"]:checked')]
        .filter((input) => data.has(input.name));
      const rankedCollection = rankCollectionAnswers(selected);
      const title = rankedCollection?.title || this.result.dataset.fallbackTitle || '';
      const url = rankedCollection?.url || this.result.dataset.fallbackUrl || '/collections/all';
      const titleNode = this.querySelector('[data-cd-finder-result-title]');
      const link = this.querySelector('[data-cd-finder-result-link]');
      if (titleNode) titleNode.textContent = title;
      if (link) link.href = url;
      this.questions.forEach((question) => { question.hidden = true; });
      this.result.hidden = false;
      this.result.focus();
      history.replaceState(null, '', `${location.pathname}#result`);
    }

    restart() {
      this.form.reset();
      this.index = 0;
      history.replaceState(null, '', location.pathname);
      this.render(true);
    }
  }
  customElements.define('cd-sleep-finder', CloudDreamSleepFinder);
}
